enum ChatType {
  INTERNAL = 'internal',
  EXTERNAL = 'external',
}

export default ChatType;

export interface ChatTypeVisitor<Result> {
  internal(): Result;

  external(): Result;
}

export function visitChatType<Result>(type: ChatType, visitor: ChatTypeVisitor<Result>): Result {
  switch (type) {
    case ChatType.INTERNAL:
      return visitor.internal();
    case ChatType.EXTERNAL:
      return visitor.external();
    default:
      throw new Error(`unexpected chat type ${type}`);
  }
}